import { getStaggerDelayMs } from '../shared/geatEasedStaggerDelay'
import { getNormalizedStaggerIndex, getNormalizedStaggerLength } from '../shared/normalizeStaggerTargets'

var clearNavStaggerDevOverlay = function () {}
var installNavStaggerDevModeGlobals = function () {}
var isNavStaggerDevModeEnabled = function () {
	return false
}
var logNavStaggerDebug = function () {}
var renderNavStaggerDevOverlay = function () {}

                    
var NAV_STAGGER_DEV_OVERLAY_ID = 'lay-nav-stagger-dev-overlay'
var NAV_STAGGER_DEV_STYLE_ID = 'lay-nav-stagger-dev-overlay-styles'
var NAV_STAGGER_OUT_DEV_STORAGE_KEY = 'lay-nav-stagger-dev-mode_v1'
var NAV_STAGGER_IN_DEV_STORAGE_KEY = 'lay-nav-stagger-in-dev-mode_v1'
var navStaggerDevClassObservers = []
var navStaggerDevClassHistory = []

var getNavStaggerDevModeConfig = function (mode) {
	if (mode === 'in') {
		return {
			windowKey: 'layNavStaggerInDevMode',
			storageKey: NAV_STAGGER_IN_DEV_STORAGE_KEY,
			urlParam: 'lay-nav-stagger-in-dev',
		}
	}
	return {
		windowKey: 'layNavStaggerDevMode',
		storageKey: NAV_STAGGER_OUT_DEV_STORAGE_KEY,
		urlParam: 'lay-nav-stagger-dev',
	}
}

isNavStaggerDevModeEnabled = function (mode) {
	if (typeof window === 'undefined') {
		return false
	}
	var config = getNavStaggerDevModeConfig(mode)
	if (window[config.windowKey] === true || window[config.windowKey] === '1') {
		return true
	}
	try {
		var params = new URLSearchParams(window.location.search)
		if (params.get(config.urlParam) === '1') {
			return true
		}
	} catch (e) {}
	try {
		if (window.localStorage && window.localStorage.getItem(config.storageKey) === '1') {
			return true
		}
	} catch (e) {}
	return false
}

var setNavStaggerDevMode = function (mode, enabled) {
	var config = getNavStaggerDevModeConfig(mode)
	window[config.windowKey] = typeof enabled === 'undefined' ? !isNavStaggerDevModeEnabled(mode) : !!enabled
	try {
		if (window.localStorage) {
			if (window[config.windowKey]) {
				window.localStorage.setItem(config.storageKey, '1')
			} else {
				window.localStorage.removeItem(config.storageKey)
			}
		}
	} catch (e) {}
	if (!window[config.windowKey] && !isNavStaggerDevModeEnabled('out') && !isNavStaggerDevModeEnabled('in')) {
		clearNavStaggerDevOverlay()
	}
	return window[config.windowKey]
}

installNavStaggerDevModeGlobals = function () {
	if (typeof window === 'undefined') {
		return
	}
	if (!window.layToggleNavStaggerDevMode) {
		window.layToggleNavStaggerDevMode = function (enabled) {
			return setNavStaggerDevMode('out', enabled)
		}
		window.layToggleNavStaggerOutDevMode = window.layToggleNavStaggerDevMode
	}
	if (!window.layToggleNavStaggerInDevMode) {
		window.layToggleNavStaggerInDevMode = function (enabled) {
			return setNavStaggerDevMode('in', enabled)
		}
	}
	window.layClearNavStaggerDevOverlay = clearNavStaggerDevOverlay
}

var injectNavStaggerDevStyles = function () {
	if (document.getElementById(NAV_STAGGER_DEV_STYLE_ID)) {
		return
	}
	var style = document.createElement('style')
	style.id = NAV_STAGGER_DEV_STYLE_ID
	style.textContent = `
		#${NAV_STAGGER_DEV_OVERLAY_ID} {
			position: fixed;
			inset: 0;
			z-index: 2147483646;
			pointer-events: none;
			font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
		}
		#${NAV_STAGGER_DEV_OVERLAY_ID} .lay-nav-stagger-dev-box {
			position: fixed;
			box-sizing: border-box;
			border: 2px solid rgba(255, 0, 0, 0.9);
			background: rgba(255, 0, 0, 0.04);
		}
		#${NAV_STAGGER_DEV_OVERLAY_ID} .lay-nav-stagger-dev-inner-box {
			position: fixed;
			box-sizing: border-box;
			border: 2px dashed rgba(255, 255, 0, 0.95);
			background: rgba(255, 255, 0, 0.08);
		}
		#${NAV_STAGGER_DEV_OVERLAY_ID} .lay-nav-stagger-dev-label {
			position: fixed;
			box-sizing: border-box;
			width: 220px;
			max-width: calc(100vw - 12px);
			max-height: min(180px, calc(100vh - 12px));
			overflow: auto;
			padding: 4px 6px;
			border-radius: 3px;
			background: rgba(255, 0, 0, 0.92);
			color: #fff;
			font-size: 11px;
			line-height: 1.25;
			font-weight: 700;
			pointer-events: auto;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
			white-space: normal;
			overflow-wrap: anywhere;
		}
		#${NAV_STAGGER_DEV_OVERLAY_ID} .lay-nav-stagger-dev-label small {
			display: block;
			font-size: 10px;
			font-weight: 500;
			opacity: 0.95;
		}
		#${NAV_STAGGER_DEV_OVERLAY_ID} .lay-nav-stagger-dev-class-history {
			margin-top: 3px;
			padding-top: 3px;
			border-top: 1px solid rgba(255, 255, 255, 0.35);
		}
	`
	document.head.appendChild(style)
}

var clearNavStaggerDevClassObservers = function () {
	for (var i = 0; i < navStaggerDevClassObservers.length; i++) {
		navStaggerDevClassObservers[i].disconnect()
	}
	navStaggerDevClassObservers = []
}

clearNavStaggerDevOverlay = function () {
	clearNavStaggerDevClassObservers()
	var overlay = document.getElementById(NAV_STAGGER_DEV_OVERLAY_ID)
	if (overlay && overlay.parentNode) {
		overlay.parentNode.removeChild(overlay)
	}
}

var getNavStaggerDebugKind = function (el) {
	if (!el || !el.matches) {
		return 'unknown'
	}
	if (el.matches('.thumbnail-wrap')) {
		return 'thumbnail-wrap'
	}
	if (el.matches('.lay-thumbnailgrid-load-more-wrap')) {
		return 'thumbnailgrid-load-more-wrap'
	}
	if (el.matches('.element-wrap')) {
		return 'element-wrap'
	}
	if (el.matches('.lay-elementgrid-load-more-wrap')) {
		return 'elementgrid-load-more-wrap'
	}
	if (el.matches('.lay-product')) {
		return 'product'
	}
	if (el.matches('.lay-productsgrid-load-more-wrap')) {
		return 'productsgrid-load-more-wrap'
	}
	if (el.matches('.lay-news-element-row')) {
		return 'news-row'
	}
	if (el.matches('.lay-news-load-more-wrap')) {
		return 'news-load-more-wrap'
	}
	if (el.matches('.col')) {
		var dataType = el.getAttribute('data-type')
		if (dataType) {
			return 'col:' + dataType
		}
		for (var i = 0; i < el.classList.length; i++) {
			var cls = el.classList[i]
			if (cls.indexOf('type-') === 0) {
				return 'col:' + cls.slice(5)
			}
		}
		return 'col'
	}
	return el.tagName ? el.tagName.toLowerCase() : 'unknown'
}

var getNavStaggerClassToken = function (el, prefix) {
	if (!el || !el.classList) {
		return ''
	}
	for (var i = 0; i < el.classList.length; i++) {
		var cls = el.classList[i]
		if (cls.indexOf(prefix) === 0) {
			return cls
		}
	}
	return ''
}

var escapeNavStaggerDebugHtml = function (str) {
	return String(str).replace(/[&<>"']/g, function (ch) {
		switch (ch) {
			case '&':
				return '&amp;'
			case '<':
				return '&lt;'
			case '>':
				return '&gt;'
			case '"':
				return '&quot;'
			case "'":
				return '&#39;'
		}
		return ch
	})
}

var getNavStaggerClassDebugTimestamp = function (startTime) {
	try {
		return Math.round(performance.now() - startTime)
	} catch (e) {
		return 0
	}
}

var updateNavStaggerClassHistoryLabel = function (history, classLine, historyLine) {
	var latest = history[history.length - 1]
	classLine.innerHTML = 'cls now: ' + escapeNavStaggerDebugHtml(latest.className)
	historyLine.innerHTML = 'class history:<br>' + history.map(function (entry) {
		var styleText = 'inline o:' + entry.inlineStyle.opacity +
			' ty:' + entry.inlineStyle.transform +
			' - computed o:' + entry.computedStyle.opacity +
			' ty:' + entry.computedStyle.transform +
			' td:' + entry.computedStyle.transitionDuration
		return 't+' + entry.ms + 'ms: ' + escapeNavStaggerDebugHtml(entry.className) + '<br>' + escapeNavStaggerDebugHtml(styleText)
	}).join('<br>')
}

var trackNavStaggerDebugClasses = function (el, slotLabel, classLine, historyLine, startTime) {
	if (!el || !window.MutationObserver) {
		return
	}
	var history = []
	var getStyleSnapshot = function () {
		var inlineStyle = {
			opacity: el.style ? (el.style.opacity || '') : '',
			transform: el.style ? (el.style.transform || '') : '',
			transition: el.style ? (el.style.transition || '') : '',
			transitionDelay: el.style ? (el.style.transitionDelay || '') : '',
		}
		var computedStyle = {
			opacity: '',
			transform: '',
			transitionProperty: '',
			transitionDuration: '',
			transitionDelay: '',
		}
		try {
			var computed = window.getComputedStyle(el)
			computedStyle.opacity = computed.opacity
			computedStyle.transform = computed.transform
			computedStyle.transitionProperty = computed.transitionProperty
			computedStyle.transitionDuration = computed.transitionDuration
			computedStyle.transitionDelay = computed.transitionDelay
		} catch (e) {}
		return {
			inlineStyle: inlineStyle,
			computedStyle: computedStyle,
		}
	}
	var recordClassName = function () {
		var className = (el.className || '').toString()
		if (history.length > 0 && history[history.length - 1].className === className) {
			return
		}
		var styleSnapshot = getStyleSnapshot()
		history.push({
			ms: getNavStaggerClassDebugTimestamp(startTime),
			slot: slotLabel,
			className: className,
			classList: el.classList ? Array.prototype.slice.call(el.classList) : [],
			inlineStyle: styleSnapshot.inlineStyle,
			computedStyle: styleSnapshot.computedStyle,
		})
		navStaggerDevClassHistory.push(history[history.length - 1])
		try {
			window.layNavStaggerDevClassHistory = navStaggerDevClassHistory
		} catch (e) {}
		updateNavStaggerClassHistoryLabel(history, classLine, historyLine)
	}
	recordClassName()
	var observer = new MutationObserver(function (mutations) {
		for (var i = 0; i < mutations.length; i++) {
			if (mutations[i].attributeName === 'class') {
				recordClassName()
				break
			}
		}
	})
	observer.observe(el, {
		attributes: true,
		attributeFilter: ['class'],
	})
	navStaggerDevClassObservers.push(observer)
}

var getNavStaggerTranslateLabel = function (el, options) {
	options = options || {}
	var transitionName = options.transitionIn || options.transitionOut || layData.navigation_transition_out
	var mode = options.debugMode || options.direction || (options.transitionIn ? 'in' : 'out')
	var val = el && el._layEffectiveTranslate !== undefined ? el._layEffectiveTranslate : 0
	if (mode === 'in') {
		if (transitionName === 'stagger-up' || transitionName === 'up') {
			return 'y:' + Math.round(val) + 'px -> 0'
		}
		if (transitionName === 'stagger-down' || transitionName === 'down') {
			return 'y:' + Math.round(-val) + 'px -> 0'
		}
		return 'y:0px -> 0'
	}
	if (transitionName === 'stagger-up' || transitionName === 'up') {
		val = -val
	}
	return 'y:' + Math.round(val) + 'px'
}

var getRoundedRect = function (el) {
	var rect = el.getBoundingClientRect()
	return {
		top: Math.round(rect.top),
		bottom: Math.round(rect.bottom),
		left: Math.round(rect.left),
		right: Math.round(rect.right),
		width: Math.round(rect.width),
		height: Math.round(rect.height),
	}
}

var getNavStaggerInnerDebugEl = function (el) {
	if (!el || !el.matches || !el.matches('.col.type-text')) {
		return null
	}
	return el.querySelector('.text')
}

var getNavStaggerDebugTargets = function (targets, options) {
	options = options || {}
	return targets.map(function (el, index) {
		var normalizedIndex = getNormalizedStaggerIndex(el, index)
		var normalizedLength = getNormalizedStaggerLength(el, targets.length)
		var closestCol = el.closest ? el.closest('.col') : null
		var closestRow = el.closest ? el.closest('.row') : null
		var innerDebugEl = getNavStaggerInnerDebugEl(el)
		var itemIndex = -1
		if (el.parentNode && el.parentNode.children) {
			itemIndex = Array.prototype.indexOf.call(el.parentNode.children, el)
		}
		var delayMs = null
		var durationMs = null
		if (typeof options.staggerMs === 'number' && (options.delayEasing || options.easing)) {
			delayMs = Math.round(getStaggerDelayMs(normalizedIndex, normalizedLength, options.staggerMs, options.delayEasing || options.easing))
		}
		if (typeof options.baseDuration === 'number') {
			durationMs = Math.round(options.baseDuration)
		}
		var className = (el.className || '').toString()
		var classList = el.classList ? Array.prototype.slice.call(el.classList) : []
		var computed = null
		try {
			var style = window.getComputedStyle(el)
			computed = {
				opacity: style.opacity,
				transform: style.transform,
				transitionProperty: style.transitionProperty,
				transitionDuration: style.transitionDuration,
				transitionDelay: style.transitionDelay,
				animationDuration: style.animationDuration,
			}
		} catch (e) {}
		return {
			index: index,
			kind: getNavStaggerDebugKind(el),
			normalizedIndex: normalizedIndex,
			normalizedLength: normalizedLength,
			delayMs: delayMs,
			durationMs: durationMs,
			effectiveTranslate: el._layEffectiveTranslate,
			translateLabel: getNavStaggerTranslateLabel(el, options),
			rect: getRoundedRect(el),
			innerRect: innerDebugEl ? getRoundedRect(innerDebugEl) : null,
			parentItemIndex: itemIndex,
			idClass: getNavStaggerClassToken(el, 'id-'),
			rowClass: getNavStaggerClassToken(closestRow, 'row-'),
			className: className,
			classList: classList,
			classLabel: className,
			inlineStyle: el.getAttribute ? (el.getAttribute('style') || '') : '',
			computedStyle: computed,
			text: (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
			closestColClassName: closestCol ? (closestCol.className || '').toString() : '',
			closestColDataType: closestCol ? closestCol.getAttribute('data-type') : null,
			closestRowClassName: closestRow ? (closestRow.className || '').toString() : '',
		}
	})
}

logNavStaggerDebug = function (stage, targets, options) {
}

renderNavStaggerDevOverlay = function (targets, options) {
	options = options || {}
	var debugMode = options.debugMode || options.direction || 'out'
	if (!isNavStaggerDevModeEnabled(debugMode)) {
		return
	}
	clearNavStaggerDevOverlay()
	navStaggerDevClassHistory = []
	try {
		window.layNavStaggerDevClassHistory = navStaggerDevClassHistory
	} catch (e) {}
	injectNavStaggerDevStyles()
	var overlay = document.createElement('div')
	overlay.id = NAV_STAGGER_DEV_OVERLAY_ID
	document.body.appendChild(overlay)
	var navStaggerDevOverlayStartTime = performance.now()

	var debugTargets = getNavStaggerDebugTargets(targets, options)
	for (var i = 0; i < debugTargets.length; i++) {
		var t = debugTargets[i]
		var rect = t.rect
		var box = document.createElement('div')
		box.className = 'lay-nav-stagger-dev-box'
		box.style.left = rect.left + 'px'
		box.style.top = rect.top + 'px'
		box.style.width = Math.max(1, rect.width) + 'px'
		box.style.height = Math.max(1, rect.height) + 'px'
		overlay.appendChild(box)

		if (t.innerRect) {
			var innerBox = document.createElement('div')
			innerBox.className = 'lay-nav-stagger-dev-inner-box'
			innerBox.style.left = t.innerRect.left + 'px'
			innerBox.style.top = t.innerRect.top + 'px'
			innerBox.style.width = Math.max(1, t.innerRect.width) + 'px'
			innerBox.style.height = Math.max(1, t.innerRect.height) + 'px'
			overlay.appendChild(innerBox)
		}

		var label = document.createElement('div')
		label.className = 'lay-nav-stagger-dev-label'
		var meta = [t.kind]
		if (t.idClass) {
			meta.push(t.idClass)
		}
		if (t.rowClass) {
			meta.push(t.rowClass)
		}
		if (t.text) {
			meta.push('"' + t.text + '"')
		}
		var metaHtml = meta.map(escapeNavStaggerDebugHtml).join(' - ')
		var modeLabel = debugMode === 'in' ? 'IN ' : ''
		label.innerHTML = modeLabel + '#' + (i + 1) + ' slot ' + (t.normalizedIndex + 1) + '/' + t.normalizedLength +
			'<small>' + metaHtml + ' - d:' + t.delayMs + 'ms - dur:' + t.durationMs + 'ms - ' + escapeNavStaggerDebugHtml(t.translateLabel) + '</small>' +
			'<small class="lay-nav-stagger-dev-class-current">cls now: ' + escapeNavStaggerDebugHtml(t.classLabel) + '</small>' +
			'<small class="lay-nav-stagger-dev-class-history">class history:<br>t+0ms: ' + escapeNavStaggerDebugHtml(t.classLabel) + '</small>'
		overlay.appendChild(label)
		trackNavStaggerDebugClasses(targets[i], modeLabel + '#' + (i + 1), label.querySelector('.lay-nav-stagger-dev-class-current'), label.querySelector('.lay-nav-stagger-dev-class-history'), navStaggerDevOverlayStartTime)
		var labelRect = label.getBoundingClientRect()
		var labelLeft = Math.max(6, Math.min(window.innerWidth - labelRect.width - 6, rect.left))
		var preferredTop = rect.top
		if (preferredTop + labelRect.height > window.innerHeight - 6) {
			preferredTop = rect.bottom - labelRect.height
		}
		label.style.left = labelLeft + 'px'
		label.style.top = Math.max(6, Math.min(window.innerHeight - labelRect.height - 6, preferredTop)) + 'px'
	}
}

installNavStaggerDevModeGlobals()
          

export {
	clearNavStaggerDevOverlay,
	installNavStaggerDevModeGlobals,
	isNavStaggerDevModeEnabled,
	logNavStaggerDebug,
	renderNavStaggerDevOverlay,
}
